import { create } from "zustand";
import { devtools } from "zustand/middleware";
import realtimeConnection from "@services/realtime/realtimeConnection";

// The live-channel counterpart of createRESTStore: a Zustand store whose state is fed by
// messages from the hub. Feature code declares which messages it listens to, how each one
// changes the state, and what to redo after a (re)connect; it never touches the SignalR
// connection itself. Every callback gets (set, get, connection).
//
//   events: { [REALTIME_EVENTS.PAGE_LOCKED]: (set) => (lock) => set({ lock }) }
//   onConnected: (set, get, connection) => get().watched.forEach((path) => connection.invoke(…))
export function createRealtimeStore(config) {
  const {
    name, // Store name, shown in Redux DevTools
    initialState = {},
    events = {}, // { messageName: (set, get, connection) => (...messageArgs) => void }
    onConnected = null, // Runs after the first connect and every reconnect
    additionalActions = () => ({}), // Feature actions, e.g. claiming a page lock
    connection = realtimeConnection,
  } = config;

  const useStore = create(
    devtools((set, get) => ({ ...initialState, ...additionalActions(set, get, connection) }), { name }),
  );
  const { setState: set, getState: get } = useStore;

  Object.entries(events).forEach(([event, bind]) => {
    connection.on(event, bind(set, get, connection));
  });

  if (onConnected) connection.onConnected(() => onConnected(set, get, connection));

  return useStore;
}
